import { render, staticRenderFns } from "./SchoolInfoHeader.vue?vue&type=template&id=1373687b&scoped=true&"
import script from "./SchoolInfoHeader.vue?vue&type=script&lang=js&"
export * from "./SchoolInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInfoHeader.vue?vue&type=style&index=0&id=1373687b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373687b",
  null
  
)

export default component.exports